import { trackAddToWishlist } from "./analytics";
import { newEventId } from "./eventId";

/**
 * Browser + shared event_id before Stripe checkout (Reddit Add To Wishlist).
 * Backend mirrors via sendAddToWishlist using the same event_id.
 */
export const fireCheckoutIntent = async (plan, user) => {
  const event_id = newEventId();
  const planName = (plan.name || plan.planName || "subscription").toString();
  const price = plan.amount ?? plan.price ?? 0;

  await trackAddToWishlist({
    eventId: event_id,
    user: user
      ? { email: user.email, userId: user.id || user._id }
      : undefined,
    item: {
      item_id: planName.toLowerCase(),
      item_name: planName,
      item_category: "subscription",
      price,
      quantity: 1,
    },
  });

  return event_id;
};
